import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CardData } from '@shared/models';
import { paperCheckList } from '@shared/constants';
import { BtnType, CardLabel, CardTitle } from '@shared/enums';
import { Router } from '@angular/router';
import { ProfileService } from '@profile/profile.service';
import { AlertService } from '@core/services';
import { EditInfoPageMode } from '@core/constants';

@Component({
  selector: 'sp-card',
  templateUrl: './card.component.html',
  styleUrls: ['card.component.scss'],
})
export class CardComponent implements OnInit {
  cardTitle = CardTitle;
  cardLabel = CardLabel;
  paperCheckList?: string[];
  btn = BtnType;
  emergencyInfo: string[];
  isBelowLg: boolean;

  @Input() cardData: CardData;
  @Input() isPaperCheckOnly: boolean;
  @Input() isAccordion = false;
  @Input() allowUpdate = false;
  @Output() allowUpdateChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private router: Router,
    private profileService: ProfileService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.paperCheckList = this.buildPaperCheckCardList(this.isPaperCheckOnly);
  }

  buildPaperCheckCardList(isPaperCheckOnly: boolean) {
    return isPaperCheckOnly && paperCheckList;
  }

  public navigateToLink(link: string): void {
    this.profileService.canEdit().subscribe(({ canEdit }) => {
      this.allowUpdateChange.next(canEdit);
      if (canEdit) {
        this.router.navigate([link, EditInfoPageMode.Update]);
      } else {
        this.alertService.showEditingDisabledBanner();
      }
    });
  }
}

// export class AppComponent implements AfterViewInit {
//   isBelowLg: boolean;

//   constructor(private screenService: ScreenService) {}

//   ngAfterViewInit(): void {
//     this.screenService.isBelowLg().subscribe((isBelowLg: BreakpointState) => {
//       this.isBelowLg = isBelowLg.matches;
//     });
//   }
// }
